import type { QuestionnaireRevisionContext } from '@gcv/shared';
import { QuestionnaireStatus } from '@gcv/shared';

import { getLatestRevision } from './get-latest-revision';

export const getEffectiveDueDate = (
  history: QuestionnaireRevisionContext[] | undefined,
  fallback: string | undefined,
  status: QuestionnaireStatus | undefined
): string | undefined => {
  if (status === QuestionnaireStatus.Suppressed) return;
  const latest = getLatestRevision(history);
  return latest?.due_date ?? fallback;
};
